import React from 'react';
import { useTranslation } from 'react-i18next';
import { Dimensions } from 'react-native';
import { HTMLRenderer } from 'shared/components/HTMLRenderer/HTMLRenderer';
import theme from 'shared/styles/theme';

const WithHoldDialogueContent = () => {
  const { t: translatedText } = useTranslation('accounts', {
    keyPrefix: 'openSavings',
  });

  const content: string = `${translatedText('acceptCertifyText')}
    <ol>
      <li>
      ${translatedText('securityNoText')}
      </li>
      <li> 
        ${translatedText('notSubjectToBackholdText')}
      </li>
      <li>
      ${translatedText('citizenText')}
      </li>
    </ol>
  `;

  return (
    <HTMLRenderer
      contentWidth={Dimensions.get('window').width}
      htmlAsString={content}
      tagsStyles={{
        ol: {
          paddingLeft: theme.spacing.m,
          listStyleType: 'lower-alpha',
          marginTop: theme.spacing.m,
        },
      }}
    />
  );
};

export default WithHoldDialogueContent;
